import { render, staticRenderFns } from "./PaymentIssue.vue?vue&type=template&id=4182ea28"
import script from "./PaymentIssue.vue?vue&type=script&lang=js"
export * from "./PaymentIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports